import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IUnitControlCompleteCreateModel, IUnitControlCompleteModel } from '@apps-common/types/portal/unit-control'

const createMyMonitoringControl = async (model: IUnitControlCompleteCreateModel): Promise<IUnitControlCompleteModel> =>
  axios.post(`/my-monitoring/control/AddControl`, model).then((res) => res?.data?.data)

type Props = {
  model: IUnitControlCompleteCreateModel
}

export const useMyMonitoringCreateControl = (
  notify?: boolean,
  onSuccess?: (data: IUnitControlCompleteModel) => void,
  onError?: () => void
) =>
  useMutation({
    mutationKey: ['createMyMonitoringControl'],
    mutationFn: ({ model }: Props) => createMyMonitoringControl(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Created control.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to create control, please try again.')
      }
      if (onError) {
        onError()
      }
    },
    throwOnError: false
  })
